





































































	import { Vue, Component, Prop  } from "../../Infrastructure/CorBase/CoreBase";  

				@Component
				export default class BaseTLModalDialogEditable extends Vue { 
			
					@Prop({ type: String, required: true, default: "" }) id!: string;
					@Prop({ type: String, required: false, default: "" }) type!: string;

					controlInput(evt: any, order: number) {
						if (order == 1 && this.formData.code1.length>3)
							evt.returnValue = false;
                        if (order == 2 && this.formData.code2.length > 3)
							evt.returnValue = false;
                        if (order == 3 && this.formData.code3.length > 3)
							evt.returnValue = false;

						//if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57) && !(evt.charCode == 45)) {
						//	evt.returnValue = false;
						//}
						return true;
					}

					inputChange(order: number) {
                        if (order == 1) {
                            if (this.formData.code1.length == 4) {
                                let input: HTMLElement = this.$refs.code2 as HTMLElement;
                                input.focus();
                            }
						}
                        else if (order == 2) {
                            if (this.formData.code2.length == 4) {
                                let input: HTMLElement = this.$refs.code3 as HTMLElement;
                                input.focus();
							}
                            if (this.formData.code2.length == 0) {
                                let input: HTMLElement = this.$refs.code1 as HTMLElement;
                                input.focus();
                            }
						}
                        else if (order == 3) {
                            if (this.formData.code3.length == 0) {
                                let input: HTMLElement = this.$refs.code2 as HTMLElement;
                                input.focus();
                            }
                        }
					}

					protected labelWidth: string = "3";
					protected inputWidth: string = "8";

					//type pro zobrazeni
					protected  typeAdoption: string = 'AdoptionCode';		

					showAdoptionCode(): boolean {
						return this.type == this.typeAdoption;
					}

					protected name(): string {
						var result = '';
						if (this.type == this.typeAdoption) {
							return this.$t('baseModalDialogEditable.tagHeadAdoption').toString();
						}
						return result;
					}

					formData = {
						adoptionCode: '' as string,
                        code1: '',
                        code2: '',
						code3: '',

					};				

					save(): void {
						this.formData.adoptionCode = this.formData.code1 + "-" + this.formData.code2 + "-" + this.formData.code3;
						this.$emit('use', this.formData);
					}				
										
					isVisible(): boolean {						
						return document.getElementById(this.id) != null;
					}

					correctAdoptionCode = false;
					isCorrectAdoptionCode(value: any) {
						this.correctAdoptionCode = value;
					}

					correctAdoption() {
						return this.formData.code1.length == 4 && this.formData.code2.length == 4 && this.formData.code3.length == 4;
					}

                    goBack(item: any) {
                        this.$emit('goBack', item);
                        this.$bvModal.hide(this.id);
                    }

					created() {					
					}

	}

